import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import sortbydot from '../../assets/image/sort_by_group.svg';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../component/ui/Button';
import Table from '../../component/table/Table';
import Pagination from '../../component/pagination';
import { ExportTable } from '../../store/action/export/Export';
import {
	fetchPurchaseReceive,
	generatePurchaseReceivePdf,
	getPurchaseReceives,
	updatePurchaseReceiveStatus,
} from '../../services/purchase_receive';
import { getDate } from '../../utils/dateUtils';
import FullCircle from '../../assets/image/full_circle.png';
import HalfCircle from '../../assets/image/half_circle.png';
import EmptyCircle from '../../assets/image/empty_circle.png';
import addFilter from '../../assets/image/AddFilter.svg';
import clearAllFilter from '../../assets/image/clearAllFilter.svg';
import advanceFilterIcon from '../../assets/image/advanceFilter_white.svg';
import { toast } from 'react-toastify';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import DeletePurchaseReceiveModel from './components/DeletePurchaseReceiveModel';
import AdvanceFilterSelectInput from '../../component/Filter/AdvanceFilterSelectInput';
import AdvanceFilter from '../../component/Filter/AdvanceFilter';
import advanceFilterOptions from '../../component/Filter/advanceFilterOptions';
import {
	clearAdvanceFilter,
	removeSelectedInput,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setAdvanceFilterTotalPage,
	setSelectedInput,
	setSelectedInputData,
	setSelectedInputValue,
} from '../../store/action/advanceFilter';
import { getFiltersParams } from '../../helper';
import PageLoader from '../../component/PageLoader';
import { hasPermission } from '../../utils/controller';
import DataNotFound from '../components/dataNotFound';

const sortIconMap = {
	asc: <IoIosArrowRoundUp />,
	desc: <IoIosArrowRoundDown />,
};

const PurchaseReceived = () => {
	const suburl = localStorage.getItem('suburl');
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const {
		page: advanceFilterPage,
		totalPages: advanceFilterTotalPages,
		pageSize: advanceFilterPageSize,
		orderBy: advanceFilterOrderby,
		sortBy: advanceFilterSortBy,
		selectedInputs,
		isAdvanceFilterApplied,
	} = useSelector((state) => state.advanceFilter);
	const [loader, setLoader] = useState(false);
	const [bulkAction, setBulkAction] = useState([]);
	const [headerDropDown, setHeaderDropDown] = useState('All Purchase Receive');
	const [sortDirection, setSortDirection] = useState({ purchase_receive_id: 'asc' });
	const [isAdvanceFilterOpen, setIsAdvanceFilterOpen] = useState(false);
	const [isDeleteBulkConfirmationModalOpen, setIsDeleteBulkConfirmationModalOpen] = useState(false);
	const [selectedPRListForDelete, setSelectedPRListForDelete] = useState([]);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);

	const [loading, setLoading] = useState({
		pdf: {
			button: 'pdf',
			isLoading: false,
		},
		download: {
			button: 'download',
			isLoading: false,
		},
	});
	const [purchaseReceiveParams, setPurchaseReceiveParams] = useState({
		page: 1,
		pageSize: 20,
		orderBy: 'created_at',
		sortBy: 'desc',
		filters: {},
	});
	const [purchaseReceive, setPurchaseReceive] = useState({
		currentPage: 1,
		totalPages: 0,
		data: [],
	});
	const [deselectRows, setDeselectRows] = useState(null);
	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};

	const PurchaseReceivedColoum = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},

		{
			field: 'DATE',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 93,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ orderBy: 'receive_date', sortBy: 'asc' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							DATE
							<span className="sort-icon">{sortIconMap[sortDirection?.receive_date]}</span>
						</p>
					</div>
				</div>
			),
		},

		{
			field: 'PR#',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 75,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() =>
						sortDataList({
							orderBy: 'purchase_receive_id',
							sortBy: 'asc',
						})
					}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							PR#
							<span className="sort-icon">{sortIconMap[sortDirection?.purchase_receive_id]}</span>
						</p>
					</div>
				</div>
			),
			cellRenderer: (params) => {
				const PR = JSON.parse(params.data.PR);
				return (
					<p className="mb-0">
						{PR?.pr}
						{PR?.status === 0 && (
							<span className="badge bg-secondary rounded-pill ms-2 px-2 py-1 fs-11">Draft</span>
						)}
					</p>
				);
			},
		},

		{
			field: 'PO#',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 75,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() =>
						sortDataList({
							orderBy: 'purchase_order_number',
							sortBy: 'asc',
						})
					}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							PO#
							<span className="sort-icon">{sortIconMap[sortDirection?.purchase_order_number]}</span>
						</p>
					</div>
				</div>
			),
		},

		{
			field: 'VENDOR NAME',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 115,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ orderBy: 'vendor_name', sortBy: 'asc' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							VENDOR NAME
							<span className="sort-icon">{sortIconMap[sortDirection?.vendor_name]}</span>
						</p>
					</div>
				</div>
			),
		},

		{
			field: 'RECEIVED',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 80,
			maxWidth: 120,
			flex: 1,
			cellClass: 'center-align',
			cellRenderer: (params) => {
				const status = params.data?.RECEIVED || 0;
				if (status === 1) {
					return (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								height: '100%',
							}}
						>
							{' '}
							<img src={FullCircle} />
						</div>
					);
				}
				return (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							height: '100%',
						}}
					>
						<img src={EmptyCircle} />
					</div>
				);
			},
		},
		{
			field: 'BILLED',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 80,
			maxWidth: 100,
			flex: 1,
			cellClass: 'center-align',
			cellRenderer: (params) => {
				const status = JSON.parse(params.data?.BILLED);
				if (status.is_billed === 1) {
					return (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								height: '100%',
							}}
						>
							<img
								src={FullCircle}
								alt=""
								style={{ alignItems: 'center' }}
							/>
						</div>
					);
				}
				if (status.is_partially_billed === 1) {
					return (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								height: '100%',
							}}
						>
							<img
								src={HalfCircle}
								alt=""
								style={{ alignItems: 'center' }}
							/>
						</div>
					);
				}
				return (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							height: '100%',
						}}
					>
						<img
							src={EmptyCircle}
							alt=""
							style={{ alignItems: 'center' }}
						/>
					</div>
				);
			},
		},
	];

	const navigateRouter = (path) => {
		navigate(path);
	};

	const onRowClick = (id) => {
		if (id && hasPermission('purchases.purchase_receives.view', user?.role?.role_permissions)) {
			navigate(`/user/${suburl}/purchases-receive-details/${id}`);
		}
	};

	const exportData = (param) => {
		ExportTable(param);
	};

	async function handleBulkDelete() {
		try {
			const body = {
				purchase_receive_id: bulkAction,
				status: 'is_deleted',
				value: true,
			};

			const billedPR = bulkAction.filter((id) => {
				const row = purchaseReceive?.data?.find((pr) => pr?.id === id);
				return row && JSON.parse(row.BILLED).is_billed;
			});

			if (billedPR.length > 0) {
				const ids = billedPR.map((pr) => {
					return `PR-${pr}`;
				});
				throw new Error(
					`The following PR are billed and cannot be deleted: ${ids?.join(',')}! Delete the associated Purchase Bill before deleting the Purchase Receive.`,
				);
			}
			await updatePurchaseReceiveStatus(body);
			toast.success('Purchase Order Deleted.');
			setIsDeleteBulkConfirmationModalOpen(false);
			setBulkAction(false);
			setBulkAction([]);
			deselectRows && deselectRows();
			handleFetchPurchaseReceive();
		} catch (error) {
			toast.error(error?.message || 'Something went wrong');
		}
	}

	async function handlePRPrintAndDownloadPdf(type = 'print') {
		try {
			setLoading((prev) => {
				const obj = {};
				obj.pdf = {
					button: type,
					isLoading: true,
				};

				return {
					...prev,
					...obj,
				};
			});
			const pdf_details = await generatePurchaseReceivePdf(bulkAction.join(','), true);
			const url = pdf_details.signed_url;

			if (type === 'print') {
				window.open(url, '_blank');
			}

			if (type === 'download') {
				const fileName = `merged_purchase_receives_${Date.now()}.pdf`;
				const response = await fetch(url);
				const blob = await response.blob();
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobUrl);
			}
		} catch (err) {
		} finally {
			setLoading((prev) => ({
				...prev,
				pdf: {
					...prev.pdf,
					isLoading: false,
				},
				download: {
					...prev.download,
					isLoading: false,
				},
			}));
		}
	}

	const FilterDatalist = (param, value, dropDownData) => {
		if (isAdvanceFilterApplied && dropDownData === 'All Purchase Receive') {
			dispatch(clearAdvanceFilter());
			setHeaderDropDown('All Purchase Receive');
			return;
		}
		setHeaderDropDown(dropDownData);
		const updatedSelectedInput = selectedInputs.map((input) => {
			if (input.key === 'status') {
				return {
					...input,
					value: dropDownData,
				};
			}
			return input;
		});
		dispatch(setSelectedInput({ key: 'status', label: 'Status' }));
		dispatch(setSelectedInputValue({ key: 'status', value: dropDownData }));
		dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
		const selectInputData = [
			{ key: 'is_draft', value: 'Draft' },
			{ key: 'is_received', value: 'Received' },
			{ key: 'is_billed', value: 'Billed' },
			{ key: 'is_not_billed', value: 'Not Billed' },
			{ key: 'is_received_and_is_billed', value: 'Received and Billed' },
			{ key: 'is_received_and_is_not_billed', value: 'Received and Not Billed' },
		];
		dispatch(setSelectedInputData({ key: 'status', data: selectInputData }));
		const params = getFiltersParams(updatedSelectedInput);
		handleApplyFilters(params);
	};

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.orderBy] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.orderBy]: newDirection });
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilter({ orderBy: param.orderBy, sortBy: newDirection }));
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			setPurchaseReceiveParams((prev) => ({
				...prev,
				orderBy: param.orderBy,
				sortBy: newDirection,
				filters: {},
			}));
		}
	};

	const handlePageChange = (page) => {
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilterPage({ page: page }));
		} else {
			setPurchaseReceiveParams((prev) => ({
				...prev,
				page,
			}));
		}
	};

	async function handleFetchPurchaseReceive() {
		try {
			setLoader(true);
			const { purchaseReceives, totalPages } = await getPurchaseReceives(purchaseReceiveParams);
			const tableData = purchaseReceives.map((pr) => {
				return {
					id: pr.purchase_receive_id,
					DATE: getDate(pr.receive_date),
					PR: JSON.stringify({
						pr: pr?.purchase_receive_number || 'N/A',
						status: pr?.status,
					}),
					'PO#': pr.purchase_order_number || pr.purchase_order_number,
					'VENDOR NAME': pr.vendor_name,
					RECEIVED: pr?.status,
					BILLED: JSON.stringify({
						is_billed: pr?.is_billed,
						is_partially_billed: pr?.is_partially_billed,
					}),
				};
			});
			setPurchaseReceive((prev) => ({
				...prev,
				currentPage: 1,
				data: tableData ?? [],
				totalPages,
			}));
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setLoader(false);
		}
	}

	//New Filter Start
	async function handleOnFocusSelectedFilterInput(key) {
		try {
			let selectInputData = [];
			if (key === 'status') {
				selectInputData = [
					{ key: 'is_draft', value: 'Draft' },
					{ key: 'is_received', value: 'Received' },
					{ key: 'is_billed', value: 'Billed' },
					{ key: 'is_not_billed', value: 'Not Billed' },
					{ key: 'is_received_and_is_billed', value: 'Received and Billed' },
					{ key: 'is_received_and_is_not_billed', value: 'Received and Not Billed' },
				];
			} else {
				const { purchaseReceive } = await fetchPurchaseReceive({
					pageSize: 1000,
					filterBy: key,
					filterValue: '',
				});
				selectInputData = purchaseReceive?.reduce((acc, pr) => {
					if (key === 'vendor_name') {
						if (acc.find((item) => item.key === pr.vendor?.vendor_name)) {
							return acc;
						}
						acc.push({
							key: pr.vendor?.vendor_name,
							value: pr.vendor?.vendor_name,
						});
						return acc;
					} else if (key === 'purchase_order_number') {
						if (acc.find((item) => item.key === pr.purchase_order?.purchase_order_number)) {
							return acc;
						}
						acc.push({
							key: pr.purchase_order?.purchase_order_number,
							value: pr.purchase_order?.purchase_order_number,
						});
						return acc;
					} else if (key === 'purchase_receive_number') {
						if (pr.purchase_receive_number) {
							acc.push({
								key: pr[key],
								value: pr[key],
							});
							return acc;
						}
						return acc;
					} else {
						acc.push({
							key: pr[key],
							value: pr[key],
						});
						return acc;
					}
				}, []);
			}

			dispatch(setSelectedInputData({ key, data: selectInputData }));
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	async function searchSelectedInputItems(key, value) {
		try {
			let selectInputData = [];
			if (key === 'status') {
				selectInputData = [
					{ key: 'is_draft', value: 'Draft' },
					{ key: 'is_received', value: 'Received' },
					{ key: 'is_billed', value: 'Billed' },
					{ key: 'is_not_billed', value: 'Not Billed' },
					{ key: 'is_received_and_is_billed', value: 'Received and Billed' },
					{ key: 'is_received_and_is_not_billed', value: 'Received and Not Billed' },
				];
			} else {
				const { purchaseReceive } = await fetchPurchaseReceive({
					pageSize: 1000,
					filterBy: key,
					filterValue: value,
				});
				selectInputData = purchaseReceive?.map((po) => ({
					key:
						key === 'purchase_order_number'
							? po['purchase_order']?.purchase_order_number
							: key === 'vendor_name'
								? po['vendor']?.vendor_name
								: po[key],
					value:
						key === 'purchase_order_number'
							? po['purchase_order']?.purchase_order_number
							: key === 'vendor_name'
								? po['vendor']?.vendor_name
								: po[key],
				}));
			}

			dispatch(setSelectedInputData({ key, data: selectInputData }));
		} catch (error) {
			toast.error(error?.message || 'Something went wrong!');
		}
	}

	async function handleApplyFilters(params) {
		try {
			if (Object.keys(params).length === 0) return;
			if (params.status) {
				setHeaderDropDown(params.status);
			}
			const { purchaseReceives, page, totalPages } = await getPurchaseReceives({
				orderBy: advanceFilterOrderby,
				sortBy: advanceFilterSortBy,
				page: advanceFilterPage,
				pageSize: advanceFilterPageSize,
				filters: params,
			});
			const purchaseReceivedFilterData = purchaseReceives.map((pr) => {
				return {
					id: pr.purchase_receive_id,
					DATE: getDate(pr.receive_date),
					PR: JSON.stringify({
						pr: pr?.purchase_receive_number || 'PR-' + pr?.purchase_receive_id,
						status: pr?.status,
					}),
					'PO#': pr?.purchase_order_number || pr?.purchase_order_number,
					'VENDOR NAME': pr.vendor_name,
					STATUS: pr?.status,
					RECEIVED: pr?.status,
					BILLED: JSON.stringify({
						is_billed: pr?.is_billed,
						is_partially_billed: pr?.is_partially_billed,
					}),
				};
			});
			setPurchaseReceive((prev) => ({
				...prev,
				currentPage: page,
				data: purchaseReceivedFilterData.length > 0 ? purchaseReceivedFilterData : [],
				totalPages,
			}));
			dispatch(setAdvanceFilterTotalPage({ totalPages: totalPages }));
			setIsAdvanceFilterOpen(false);
		} catch (error) {
			toast.error(error?.message || 'Something went wrong! Try again.');
		}
	}

	useEffect(() => {
		if (isAdvanceFilterApplied) {
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			handleFetchPurchaseReceive();
		}
	}, [purchaseReceiveParams, advanceFilterPage, advanceFilterPageSize, isAdvanceFilterApplied]);

	return (
		<div>
			{bulkAction && bulkAction.length > 0 ? (
				<div
					className="product-pg-header"
					style={{ padding: '1.6rem 1rem' }}
				>
					<div className="dropdown text-end">
						<p className="d-block link-dark text-decoration-none">Bulk Actions</p>
					</div>
					<div className="add-product-button">
						<Button
							type="button"
							button="Print"
							disabled={
								!hasPermission(
									'purchases.purchase_receives.download_print_pdf',
									user?.role?.role_permissions,
								)
							}
							className="mt-0 px-4 btn-gray"
							loader={loading.pdf.isLoading}
							onClick={() => handlePRPrintAndDownloadPdf('print')}
						/>
						<Button
							type="button"
							button="Download"
							disabled={
								!hasPermission(
									'purchases.purchase_receives.download_print_pdf',
									user?.role?.role_permissions,
								)
							}
							loader={loading.download.isLoading}
							className="mt-0 px-4 btn-gray"
							onClick={() => handlePRPrintAndDownloadPdf('download')}
						/>
						<Button
							type="button"
							className="mt-0 btn-danger add-pro"
							button=""
							close
							onClick={() => {
								setBulkAction(false);
								setBulkAction([]);
								deselectRows && deselectRows();
							}}
						/>
					</div>
				</div>
			) : (
				<div className="product-pg-header add-product">
					<div
						className="dropdown text-end d-flex"
						style={{ gap: '12px', alignItems: 'center', display: 'flex' }}
					>
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist({ filters: {} }, '', 'All Purchase Receive')}
								>
									All Purchase Receive
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist({ filters: { status: 0 } }, 'is_draft', 'Draft')}
								>
									Draft
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist({ filters: { status: 1 } }, 'is_received', 'Received')
									}
								>
									Received
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist({ filters: { is_billed: 1 } }, 'is_billed', 'Billed')
									}
								>
									Billed
								</a>
							</li>
						</ul>
						<div>
							{isAdvanceFilterApplied ? (
								<div>
									<button
										onClick={() => {
											dispatch(clearAdvanceFilter());
											setHeaderDropDown('All Purchase Receive');
										}}
										style={{
											background: 'transparent',
											color: '#FF0000',
											fontSize: '14px',
											cursor: 'pointer',
											fontWeight: '600',
											lineHeight: '24px',
										}}
									>
										<img
											src={clearAllFilter}
											alt=""
											style={{ width: '18px', height: '18px', marginRight: '8px' }}
										/>
										Clear All Filters
									</button>
								</div>
							) : (
								<Button
									type="button"
									button="Advanced Filters"
									className="mt-0 px-4 btn-primary"
									onClick={() => setIsAdvanceFilterOpen(true)}
									icon={advanceFilterIcon}
								/>
							)}
						</div>
					</div>

					<div className="add-product-button column-gap-0">
						<Button
							type="button"
							className="btn-primary mt-0 px-5"
							disabled={
								!hasPermission('purchases.purchase_receives.create', user?.role?.role_permissions)
							}
							button="Create New Purchase Receive"
							add
							onClick={() => navigateRouter(`/user/${suburl}/purchases-receive-create`)}
						/>
						<div className="dropdown text-end ms-3">
							<a
								href="#"
								className="d-block link-dark text-decoration-none"
								id="dropdownUser1"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<img src={sortbydot} />
							</a>
							<ul
								className="dropdown-menu font-14"
								aria-labelledby="dropdownUser1"
								style={{ minWidth: '240px' }}
							>
								<li>
									<a
										className="dropdown-item sortBy"
										style={{ cursor: 'not-allowed' }}
									>
										Sort By
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'receive_date', sortBy: 'asc' })}
									>
										Receive Date
										<span>{sortIconMap[sortDirection?.receive_date]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'created_at', sortBy: 'asc' })}
									>
										Created Time
										<span>{sortIconMap[sortDirection?.created_at]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'purchase_receive_id', sortBy: 'asc' })}
									>
										Purchase Receive
										<span>{sortIconMap[sortDirection?.purchase_receive_id]}</span>
									</a>
								</li>

								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() =>
											sortDataList({ orderBy: 'purchase_order_number', sortBy: 'asc' })
										}
									>
										Purchase Order Number
										<span>{sortIconMap[sortDirection?.purchase_order_number]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'vendor_name', sortBy: 'asc' })}
									>
										Vendor Name
										<span>{sortIconMap[sortDirection?.vendor_name]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'updated_at', sortBy: 'asc' })}
									>
										Last Modified time
										<span>{sortIconMap[sortDirection?.updated_at]}</span>
									</a>
								</li>
								<li>
									<a
										className={`dropdown-item ${!hasPermission('purchases.purchase_receives.export', user?.role?.role_permissions) ? 'disabled' : ''}`}
										onClick={() => exportData(`purchase_receive`)}
									>
										Export Purchase Receive
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() => {
											setHeaderDropDown('All Purchase Receive');
											setPurchaseReceiveParams({
												page: 1,
												pageSize: 20,
												orderBy: 'purchase_receive_id',
												sortBy: 'asc',
											});
										}}
									>
										Refresh
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			)}
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					padding: '0px 10px',
				}}
			>
				{isAdvanceFilterApplied && (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => handleOnFocusSelectedFilterInput(item?.key)}
								onChange={(value) => {}}
								onSelect={(option) => {
									if (item?.key === 'status') {
										setHeaderDropDown(option?.value);
									}
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									handleApplyFilters(params);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									if (item.key === 'status') {
										setHeaderDropDown('All Purchase Receive');
									}
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div style={{ marginBottom: '8px', cursor: 'pointer' }}>
							<img
								src={addFilter}
								alt="Apply Filter"
								onClick={() => setIsAdvanceFilterOpen(true)}
							/>
						</div>
					</div>
				)}
			</div>

			{isDeleteBulkConfirmationModalOpen && (
				<DeletePurchaseReceiveModel
					isDeleteBulkConfirmationModalOpen={isDeleteBulkConfirmationModalOpen}
					setIsDeleteBulkConfirmationModalOpen={() => {
						setIsDeleteBulkConfirmationModalOpen(false);
						setBulkAction(false);
						setBulkAction([]);
						deselectRows && deselectRows();
					}}
					selectedPRListForDelete={selectedPRListForDelete}
					handleBulkDelete={handleBulkDelete}
					purchaseReceiveLength={bulkAction.length}
				/>
			)}

			{loader ? (
				<PageLoader />
			) : purchaseReceive.data.length > 0 ? (
				<div className="productTable-body">
					<Table
						row={purchaseReceive.data}
						coloum={PurchaseReceivedColoum}
						className="productTable"
						bulkAction={bulkAction}
						onRowClick={onRowClick}
						action={setBulkAction}
						style={isAdvanceFilterApplied ? { height: 'calc(100vh - 185px)' } : {}}
						onDeselectAll={handleDeselectAll}
					/>
				</div>
			) : (
				<DataNotFound
					title={'Track your received goods effortlessly!'}
					subtitle={'Track and manage all your purchase bills easily.'}
					descriptionTitle={'Stay updated!'}
					descriptionSubTitle={'Monitor every received order and keep your stock '}
					descriptionContent={'ecords accurate — all in one place.'}
					buttonText={'Create New Purchase Receive'}
					disabled={
						!hasPermission('purchases.purchase_receives.create', user?.role?.role_permissions)
					}
					onClick={() => navigateRouter(`/user/${suburl}/purchases-receive-create`)}
				/>
			)}

			{purchaseReceive.data.length > 0 && (
				<Pagination
					currentPage={isAdvanceFilterApplied ? advanceFilterPage : purchaseReceiveParams.page}
					totalPages={
						isAdvanceFilterApplied ? advanceFilterTotalPages : purchaseReceive?.totalPages
					}
					onChangePage={handlePageChange}
					pageSize={isAdvanceFilterApplied ? advanceFilterPageSize : purchaseReceiveParams.pageSize}
					setParam={(value) => {
						if (isAdvanceFilterApplied) {
							dispatch(setAdvanceFilterPage({ page: 1, pageSize: value }));
						} else {
							setPurchaseReceiveParams((prev) => ({
								...prev,
								pageSize: value,
								page: 1,
							}));
						}
					}}
				/>
			)}

			{/* Advance Filter  */}
			{isAdvanceFilterOpen && (
				<AdvanceFilter
					modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
					isOpen={isAdvanceFilterOpen}
					advanceFilterOptions={advanceFilterOptions?.purchase_receive}
					onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
					handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
					onClose={() => {
						setIsAdvanceFilterOpen(false);
					}}
					onApply={handleApplyFilters}
				/>
			)}
		</div>
	);
};

export default PurchaseReceived;
